<template>
  <vca-card>
    <vca-row>
      <h2>{{ current.user.full_name }}</h2>
    </vca-row>
    <vca-row>
      <vca-column>
        <vca-row>
          <div class="bold">
            {{ $t("events.participations.status.header") }}
          </div>
          <div>
            {{ $t("events.participations.status." + current.status) }}
          </div>
        </vca-row>
        <vca-row>
          <div class="bold">{{ $t("events.crew.label") }}</div>
          <span>
            {{ getCrew }}
            <span v-if="current.user.crew && current.user.crew.name != ''">
              ({{ $t("profile.active.current." + current.user.active.status) }})
            </span>
          </span>
        </vca-row>

        <vca-row>
          <div class="bold">
            {{ $t("events.participations.supporter.email") }}
          </div>
          <div>{{ current.user.email }}</div>
        </vca-row>
        <vca-row>
          <div class="bold">
            {{ $t("events.participations.supporter.phone") }}
          </div>
          <div>{{ current.user.profile.phone }}</div>
        </vca-row>
        <vca-row>
          <div class="bold">
            {{ $t("events.participations.supporter.mattermost_username") }}
          </div>
          <div>{{ current.user.profile.mattermost_username }}</div>
        </vca-row>
        <div></div>
      </vca-column>
      <vca-column>
        <vca-row>&nbsp;</vca-row>
        <vca-row>
          <div class="bold">
            {{ $t("events.participations.supporter.age") }}
          </div>
          <div>{{ getAge(current.user.profile.birthdate) }}</div>
        </vca-row>
        <vca-row>
          <div class="bold">
            {{ $t("events.participations.supporter.gender") }}
          </div>
          <div>
            {{ getGender }}
          </div>
        </vca-row>
        <vca-row>
          <div class="bold">
            {{ $t("events.participations.created.header") }}
          </div>
          <div>{{ datetime(current.modified.created) }}</div>
        </vca-row>
        <vca-row>
          <div class="bold">
            {{ $t("events.participations.updated.header_long") }}
          </div>
          <div>{{ datetime(current.modified.updated) }}</div>
        </vca-row>
      </vca-column>
    </vca-row>
    <div class="bold">
      {{ $t("events.participations.comment") }}
    </div>
    <p>{{ current.comment }}</p>
    <div>
      <button
        v-if="
          current.event.type_of_event !== 'crew_meeting' &&
          (hasSystemPermission() || (canAccept && !eventClosed))
        "
        @click="accept()"
        class="vca-button"
      >
        {{ $t("button.accept") }}
      </button>
      <div
        v-if="
          current.event.type_of_event !== 'crew_meeting' &&
          (hasSystemPermission() || (canReject && !eventClosed))
        "
        class="vca-center"
      >
        <vca-cancel-button
          @click="reject()"
          :placeholder="$t('button.reject')"
        />
      </div>
      <div>
        <button
          v-if="canChangeASP && !eventClosed"
          @click="setAsEventAsp()"
          class="vca-button-small"
        >
          {{ $t("events.participations.event_asp.button") }}
        </button>
      </div>
      <vca-card v-if="current.status == 'withdrawn'" class="vca-center">
        <div class="bold highlight">
          {{ $t("events.participations.withdrawn") }}
        </div>
      </vca-card>
      <vca-card v-if="hasSystemPermission()" class="vca-center">
        <vca-cancel-button
          @click="doDelete()"
          :placeholder="$t('button.delete')"
        />
      </vca-card>
    </div>
  </vca-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EventParticipant",
  computed: {
    ...mapGetters({
      user: "user/current",
      hasSystemPermission: "user/roles/hasSystemPermission",
      hasPoolPermission: "user/roles/hasPoolPermission",
    }),
    canChangeASP() {
      return (
        this.$store.state.events.current.event_asp_id !==
          this.current.user.id &&
        this.current.status !== "withdrawn" &&
        (this.hasSystemPermission() ||
          (this.hasPoolPermission(this.poolEventPermissions) &&
            this.user.crew &&
            this.current.event.crew &&
            this.user.crew.crew_id === this.current.event.crew.id))
      );
    },
    getCrew() {
      return this.current.user.crew && this.current.user.crew.name != ""
        ? this.current.user.crew.name
        : " - ";
    },
    getGender() {
      return this.current.user.profile.gender
        ? this.$t("users.gender." + this.current.user.profile.gender)
        : " - ";
    },
    canReject() {
      return ["requested", "confirmed"].includes(this.current.status);
    },
    canAccept() {
      return ["requested", "rejected"].includes(this.current.status);
    },
    eventClosed() {
      return new Date() > new Date(this.current.event.end_at * 1000);
    },
    current: {
      get() {
        return this.$store.state.events.participations.current;
      },
      set(value) {
        this.$store.commit("events/participations/current", value);
      },
    },
  },
  methods: {
    accept() {
      if (
        confirm(
          this.$t("events.participations.accept.confirm", {
            0: this.current.user.full_name,
          })
        )
      ) {
        this.$store
          .dispatch({ type: "events/participations/accept" })
          .then(() => {
            this.current = null;
          });
      }
    },
    setAsEventAsp() {
      if (
        confirm(
          this.$t("events.participations.event_asp.confirm", {
            0: this.current.user.full_name,
            1: this.current.user.crew.name,
            2: this.current.event.name,
          })
        )
      ) {
        this.$store.state.events.current.event_asp_id = this.current.user.id;
        this.$store.dispatch({ type: "events/update" }).then(() => {
          this.current = null;
        });
      }
    },
    reject() {
      if (
        confirm(
          this.$t("events.participations.reject.confirm", {
            0: this.current.user.full_name,
          })
        )
      ) {
        this.$store
          .dispatch({ type: "events/participations/reject" })
          .then(() => {
            this.current = null;
          });
      }
    },
    doDelete() {
      if (
        confirm(
          this.$t("events.participations.delete.confirm", {
            0: this.current.user.full_name,
          })
        )
      ) {
        this.$store
          .dispatch({
            type: "events/participations/delete",
            data: this.current.id,
          })
          .then(() => {
            this.current = null;
            this.$store
              .dispatch({
                type: "events/participations/listEvent",
                data: this.$route.params.id,
              })
              .then((response) => {
                this.$store.commit(
                  "events/participations/list",
                  !response || response.length == 0 ? [] : response
                );
              });
          });
      }
    },
    getAge(birthdate) {
      return birthdate
        ? new Date(new Date() - new Date(birthdate * 1000)).getUTCFullYear() -
            1970
        : "-";
    },
  },
};
</script>
